// import { Suspense, lazy } from 'react'
import moment from 'moment'
import { chunkArray, europeNum, fixedNum } from '@utils/general'
import { CornerUpRight as CornerUpRightIcon, TrendingUp as TrendingUpIcon, Activity as ActivityIcon, Sun as SunIcon } from 'react-feather'
import SunCalc from 'suncalc'
// import LoadingScreen from '@components/LoadingScreen'
import Overview from './Overview'
import Components from './Components'
import Anomalies from './Anomalies'
import Production from './Production'
import Analytics from './Analytics'
import Report from './Report'
/* const Overview = lazy(() => import('./Overview'))
const Components = lazy(() => import('./Components'))
const Anomalies = lazy(() => import('./Anomalies'))
const Production = lazy(() => import('./Production'))
const Analytics = lazy(() => import('./Analytics'))
const Report = lazy(() => import('./Report')) */

export const tabs = [
  {
    value: 'overview',
    label: 'Panoramica',
    isSmall: true
  },
  /* {
    value: 'components',
    label: 'Componenti',
    isSmall: true
  }, */
  {
    value: 'production',
    label: 'Produzione',
    isSmall: true
  },
  {
    value: 'anomalies',
    label: 'Anomalie',
    isSmall: true
  },
  {
    value: 'analytics',
    label: 'Analytics',
    isSmall: false
  }
  /* {
    value: 'report',
    label: 'Report',
    isSmall: true
  } */
]

export const selectActiveTab = (currentTab, hasGlass = false) => {
  switch (currentTab) {
    case 'overview': {
      return (
        // <Suspense fallback={<LoadingScreen glass={hasGlass} />}>
        <Overview />
        // </Suspense>
      )
    }
    case 'components': {
      return (
        // <Suspense fallback={<LoadingScreen glass={hasGlass} />}>
        <Components />
        // </Suspense>
      )
    }
    case 'production': {
      return (
        // <Suspense fallback={<LoadingScreen glass={hasGlass} />}>
        <Production hasGlass={hasGlass} />
        // </Suspense>
      )
    }
    case 'anomalies': {
      return (
        // <Suspense fallback={<LoadingScreen glass={hasGlass} />}>
        <Anomalies hasGlass={hasGlass} />
        // </Suspense>
      )
    }
    case 'analytics': {
      return (
        // <Suspense fallback={<LoadingScreen glass={hasGlass} />}>
        <Analytics hasGlass={hasGlass} />
        // </Suspense>
      )
    }
    case 'report': {
      return (
        // <Suspense fallback={<LoadingScreen glass={hasGlass} />}>
        <Report hasGlass={hasGlass} />
        // </Suspense>
      )
    }
    default:
      return null
  }
}

// Funzione che presi in ingresso il typo di periodo e la data di inizio ritornano data di inizio e data di fine
export const getDatesFromPeriod = (period, now, formatString = null) => {
  let maxDate, minDate
  if (period === 'live') {
    // min e max saranno la mezzanotte di oggi e le 23:59 di oggi
    minDate = moment(now).set({ hours: 0, minute: 0, second: 0, millisecond: 0 })
    // maxDate = moment(now).add(1, 'day')
    maxDate = moment(now).set({ hours: 23, minute: 59, second: 59, millisecond: 900 })
  } else if (period === 'week') {
    // il min sarà il lunedì di questa settimana, il max la domenica
    //  su momento 0 è domenica, 6 è sabato, 7 è la prossima domenica
    /* minDate = moment(now).set({ hours: 0, minute: 0, second: 0, millisecond: 1 })
    minDate = moment(minDate).day(1)
    maxDate = moment(now).set({ hours: 23, minute: 59, second: 59, millisecond: 900 })
    maxDate = moment(maxDate).day(7) */
    minDate = moment(now).startOf('week')
    maxDate = moment(now).endOf('week')
  } else if (period === 'month') {
    // il min sarà l'1 del mese e il max sarà il 30/31 del mese
    // (secondo la doc moment gestisce da solo che se setti 31 ed ha 30 giorni imposta 30 e non 31)
    // https://momentjs.com/docs/#/get-set/date/
    // https://momentjs.com/docs/#/get-set/month/
    /*  minDate = moment(now).set({ hours: 0, minute: 0, second: 0, millisecond: 1 })
    minDate = moment(minDate).date(1)
    maxDate = moment(now).set({
      hours: 23,
      minute: 59,
      second: 59,
      millisecond: 900
    })
    maxDate = moment(maxDate).date(31) */
    minDate = moment(now).startOf('month')
    maxDate = moment(now).endOf('month')
  } else if (period === 'year') {
    // sarà l'anno corrente
    minDate = moment(now).set({ hours: 0, minute: 0, second: 0, millisecond: 0 })
    minDate = moment(minDate)
      .month(0)
      .date(1)
    maxDate = moment(now).set({
      hours: 23,
      minute: 59,
      second: 59,
      millisecond: 900
    })
    maxDate = moment(maxDate)
      .month(11)
      .date(31)
  }

  return formatString
    ? { minDate: moment(minDate).format(formatString), maxDate: moment(maxDate).format(formatString) }
    : { minDate: moment(minDate).toISOString(), maxDate: moment(maxDate).toISOString() }
}

// Funzione che prende in ingresso i dati ricevuti dall'api e li formatta per le card
export const decodeCardsFromApi = (dataObj) => {
  // Oggetto che contiene la configurazione delle cards
  const labelIconConfig = {
    totalExpectedEnergy: {
      icon: <CornerUpRightIcon />,
      label: 'E. Attesa'
    },
    totalExportedEnergy: {
      icon: <ActivityIcon />,
      label: 'E. Immessa'
    },
    totalProducedEnergy: {
      icon: <TrendingUpIcon />,
      label: 'E. Prodotta'
    },
    totalRadiation: {
      icon: <SunIcon />,
      label: 'Irraggiamento'
    }
  }

  return Object.keys(dataObj).map((key) => ({
    icon: (labelIconConfig[key] && labelIconConfig[key].icon) || null,
    values: [
      {
        label: (labelIconConfig[key] && labelIconConfig[key].label) || '',
        value:
          key === 'totalRadiation'
            ? dataObj[key] !== '-'
                ? dataObj[key] * 1000 >= 10000
                    ? `${europeNum(dataObj[key])} kWh/m${String.fromCodePoint(0x00B2)}`
                    : `${europeNum(dataObj[key] * 1000)} Wh/m${String.fromCodePoint(0x00B2)}`
                : '-'
            : dataObj[key] !== '-'
              ? dataObj[key] >= 1000000
                  ? `${europeNum(dataObj[key] / 1000)} Mwh`
                  : `${europeNum(dataObj[key])} kWh`
              : '-'
      }
    ]
  }))
}

// funzione che prende in ingresso i dati ricevuti dall'api e li formatta per il grafico di scostamento della produzione/pr
export const decodePrDeviationGraphFromApi = (dataObj) => {
  const { realPr, realProduction, baselinePr, baselineProduction } = dataObj
  const prValue = realPr && baselinePr ? Math.floor((Number(realPr) / Number(baselinePr)) * 100) : 0
  const productionValue =
    realProduction && baselineProduction ? Math.floor((Number(realProduction) / Number(baselineProduction)) * 100) : 0

  return {
    kwh: {
      value: productionValue,
      realValue: realProduction,
      category: 'Produzione',
      name: 'Produz. reale/attesa'
    },
    pr: {
      value: prValue,
      realValue: realPr,
      category: 'PR',
      name: 'PR reale/atteso'
    }
  }
}

// funzione che prende in ingresso i dati ricevuti dall'api e li formatta per il grafico totalizzatore
export const decodeTotalPrGraphFromApi = (dataObj) => {
  const { realPr, realProduction, baselinePr, baselineProduction } = dataObj
  const prValue = realPr && baselinePr ? Math.floor((Number(realPr) / Number(baselinePr)) * 100) : 0
  const productionValue =
    realProduction && baselineProduction ? Math.floor((Number(realProduction) / Number(baselineProduction)) * 100) : 0

  return {
    kwh: {
      value: productionValue,
      realValue: realProduction,
      name: 'Produz. reale/attesa'
    },
    pr: {
      value: prValue,
      realValue: realPr,
      name: 'PR reale/atteso'
    }
  }
}

// funzione che prende in ingresso i dati ricevuti dall'api e li formatta per il grafico dell'energia
export const decodeEnergyGraphFromApi = (dataObj, customPeriod) => {
  const periodXFormat = {
    live: 'HH:mm',
    quarter: 'HH:mm',
    week: 'DD/MM/YY',
    month: 'DD/MM/YY',
    year: 'MM/YY'
  }
  const graphConfig = {
    expectedEnergy: {
      name: 'E. Attesa'
    },
    producedEnergy: {
      name: 'E. Prodotta'
    },
    exportedEnergy: {
      name: 'E. Immessa'
    },
    irradiation: {
      name: 'Irraggiamento'
    }
  }
  // Prendo le labels (le date) dall'array dell'energia attesa che comprende tutte quelle del periodo selezionato
  const notEmptyEnergy = dataObj.expectedEnergy.length > 0
    ? dataObj.expectedEnergy
    : dataObj.producedEnergy.length > 0
      ? dataObj.producedEnergy
      : dataObj.exportedEnergy.length > 0
        ? dataObj.exportedEnergy
        : dataObj.irradiation.length > 0
          ? dataObj.irradiation
          : []

  const labels = notEmptyEnergy.map((el) => moment(el.label).format(periodXFormat[customPeriod]))
  const maxLength = dataObj.producedEnergy.length
  // lunghezza massima dell'array delle energie
  // console.log('maxLength: ', maxLength)
  const series = Object.keys(dataObj).map((key) => {
    let data = (dataObj[key] && dataObj[key].map((el) => el.value)) || []
    // Se sto manipolando l'energia attesa, annullo tutti i valori che vanno oltre l'ultimo valore utile (ora/giorno/mese) a seconda della view
    // Faccio questa operazione assumendo che il valore massimo dei dati che voglio conservare, siano in numero uguale a quelli dell'energia prodotta
    if (key === 'expectedEnergy') {
      const normalizedData = data
        // prendo tutti i valori che arrivano all'ora attuale
        .map((el, index) => (index < maxLength ? el : null))
        // e rimuovo tutti i valori null che si trovano dopo l'ora attuale
        .filter((el, index) => (index < maxLength || el !== null))
      // console.log('normalizedData: ', normalizedData)
      // console.log('normalizedData - data: ', data)
      data = normalizedData
    }
    if (key === 'irradiation') {
      // Dato che i valori di irraggiamento arrivano in kW li trasformo in W
      const normalizedData = data.map((el) => el !== null ? Number(el) * 1000 : null)
      data = normalizedData
    }
    while (data.length < labels.length) {
      data.push(null)
    }
    return {
      data,
      ...graphConfig[key]
    }
  })
  // oggetto formattato da ritornare per visualizzare il grafico
  const energyGraph = {
    labels,
    series
  }

  console.log(energyGraph)

  return energyGraph
}

// funzione che prende in ingresso i dati ricevuti dall'api e li formatta per il grafico dell'irraggiamento
export const decodeIrradiationGraphFromApi = (dataObj, customPeriod) => {
  const periodXFormat = {
    live: 'HH:mm',
    week: 'DD/MM/YY',
    month: 'DD/MM/YY',
    year: 'MM/YY'
  }

  const graphConfig = {
    producedEnergy: {
      name: 'Energia Prodotta'
    },
    irradiation: {
      name: 'Irraggiamento'
    }
  }
  // Prendo le labels (le date) dall'array dell'energia attesa che comprende tutte quelle del periodo selezionato
  const labels = dataObj.expectedEnergy.map((el) => moment(el.label).format(periodXFormat[customPeriod]))
  const energyData = dataObj.producedEnergy.map((el) => el.value)
  const irradiationData = dataObj.irradiation.map((el) => el.value !== null ? Number(el.value) * 1000 : null)
  while (energyData.length < labels.length) {
    energyData.push(null)
  }
  while (irradiationData.length < labels.length) {
    irradiationData.push(null)
  }

  const radiationGraph = {
    labels,
    energy: {
      series: [
        {
          data: energyData,
          ...graphConfig.producedEnergy
        }
      ]
    },
    radiation: {
      series: [
        {
          data: irradiationData,
          ...graphConfig.irradiation
        }
      ]
    }
  }

  return radiationGraph
}

// funzione che torna la durata formattata
export const returnDuration = (duration) => {
  const toReturn = Number(duration)
  if (duration === '' || isNaN(toReturn)) {
    return duration
  } else {
    return moment.duration(toReturn).humanize()
  }
}

// funzione che ritorna i dati per la lista delle anomalie sistemati per la view della lista
export const normalizeAnomaly = (anomaly, categories) => {
  // mi preparo l'oggetto finale
  const finalObj = {
    ...anomaly,
    name: 'N.F.',
    description: 'N.F.',
    category: '',
    subCategory: {
      label: '',
      color: ''
    },
    selected: true
  }
  // cerco config e categorie
  const thisConfig = anomaly.configuration
  if (thisConfig) {
    finalObj.name = thisConfig.name
    finalObj.description = thisConfig.description
    // cerco la categoria principale
    const thisCategory = categories.find(
      (category) => category.name === thisConfig.category
    )
    if (thisCategory) {
      finalObj.category = thisCategory.label
      // cerco la subcategory
      const thisSubCategory = thisCategory.subCategory.find(
        (sub) => sub.name === thisConfig.subCategory
      )
      if (thisSubCategory) {
        finalObj.subCategory.label = thisSubCategory.label
        finalObj.subCategory.color = thisSubCategory.color
      }
    }
  }
  // mi sistemo la durata nel caso sia ancora aperta
  if (!finalObj.duration && (!finalObj.endedAt || finalObj.endedAt === '')) {
    // DA RIMUOVERE -> ref usato per i dati demo
    const dateRef = moment()
    finalObj.duration = moment
      .duration(moment(dateRef).diff(moment(finalObj.startedAt)))
      .asMilliseconds()
    // finalObj.duration = moment.duration(finalObj.duration).asHours()
  }

  return finalObj
}

// funzione che prende in ingresso i dati ricevuti dall'api e li formatta per il grafico dell'andamento
// L'oggetto dataObj avrà una chiave per ogni proprietà richiesta
export const decodeTrendGraph = (dataObj, currentFilter) => {
  const periodXFormat = {
    raw: 'HH:mm',
    quarter: 'HH:mm',
    hourly: 'HH:mm',
    daily: 'DD/MM/YY'
  }

  // prendo il primo dispositivo disponibile
  const firstDevice = Object.keys(dataObj).length > 0 ? Object.keys(dataObj)[0] : null
  // prendo la prima proprietà del dispositivo selezionato
  const firstKey = firstDevice && Object.keys(dataObj[firstDevice]).length > 0 ? Object.keys(dataObj[firstDevice])[0] : ''
  // Prendo il livello di aggregazione
  const { aggregationType } = currentFilter
  const { elements } = currentFilter
  // Prendo le labels (le date) dall'array del primo elemento e le formatta secondo l'oggetto periodXFormat
  const labels = dataObj[firstDevice][firstKey] ? dataObj[firstDevice][firstKey].map((el) => moment(el.label).format(periodXFormat[aggregationType])) : []
  const series = elements.map(property => {
    const data = (dataObj[property.deviceId] && dataObj[property.deviceId][property.name] && dataObj[property.deviceId][property.name].map(el => el.value)) || []

    // faccio questo per avere un numero di elementi sempre omogeneo per tutte le grandezze
    while (data.length < labels.length) {
      data.push(null)
    }

    return {
      data,
      type: property.graphType || 'column',
      uom: property.uom || 'kWh',
      name: property.displayName || 'Value'
    }
  })

  // oggetto formattato da ritornare per visualizzare il grafico
  const trendGraph = {
    labels,
    axis: {
      color: '#fff'
      // yMax: 800
    },
    series
  }

  return trendGraph
}

// Funzione che prende in ingresso i dati ricevuti dalle API per i grafici di analisi di stringa e restituisce i dati nel formato giusto per essere graficati
export const decodeStringAnalysisFromApi = (dataObj) => {
  const stringAnalysisData = Object.keys(dataObj)
    .map(key => ({ ...dataObj[key] }))
    .map(element => Object.keys(element)
      .map(elKey => ({ ...element[elKey] }))).flat()

  if (stringAnalysisData.some(el => el.orientations !== undefined)) {
    const inverterStringAnalysis = stringAnalysisData
      .map(el => Object.keys(el.orientations)
        .map(orientation => ({ ...el.orientations[orientation] }))).flat()

    const chunkStringAnalysis = chunkArray(inverterStringAnalysis, 2)
    return chunkStringAnalysis
  }
  const chunkStringAnalysis = chunkArray(stringAnalysisData, 2)

  return chunkStringAnalysis
}

// Funzione che prende in ingresso i dati ricevuti dalle API per il grafico di scostamento e restituisce i dati nel formato giusto per essere graficati
export const decodeLinearRegressionGraphFromApi = (dataObj) => {
  // Array di oggetti presenti in un grafico
  const elements = Object.keys(dataObj).map(key => dataObj[key])

  let data = []
  // Se sto trattando i dati di un'analisi di impianto
  if (elements.some(el => el.plant !== undefined)) {
    data = elements.map(element => ({ ...element.plant })).map(inv => ({
      max: inv.max,
      r2: inv.r2,
      orientationName: 'Impianto',
      line: inv.line.map(el => ({ x: el.irradiation, y: el.energy })),
      points: inv.scatter.map(el => ({ x: el.irradiation, y: el.energy, date: el.label }))
    }))
  } else {
    const inverterNames = elements
      .map(element => Object.keys(element)
        .map(elementKey => element[elementKey].inverter
          ? element[elementKey].inverter.name
          : (element[elementKey].orientation && element[elementKey].orientation.name)))
      .flat()
    // Array di oggetti degli elementi da graficare
    data = elements
      .map(element => Object.keys(element)
        .map(elementKey => element[elementKey].inverters ? element[elementKey].inverters : element[elementKey].orientations)).flat()
      .map(inverter => Object.keys(inverter)
        .map(inverterKey => inverter[inverterKey])).flat()
      .map((inv, index) => ({
        max: inv.max,
        r2: inv.r2,
        orientationName: (inv.orientation && `${inverterNames[index] || ''} (${inv.orientation.name})`) || '',
        line: inv.line.map(el => ({ x: el.irradiation, y: el.energy })),
        points: inv.scatter.map(el => ({ x: el.irradiation, y: el.energy, date: el.label }))
      }))
  }
  /* const data = elements
    .map(element => Object.keys(element)
      .map(key => (
        {
          line: element[key].line.map(el => ({ x: el.irradiation, y: el.energy })),
          points: element[key].scatter.map(el => ({ x: el.irradiation, y: el.energy, date: el.label }))
        }
      ))
    ).flat() */
  return data
}

// Funzione che prende in ingresso una data di inizio e una data di fine e ritorna il tipo di aggregazione da utilizzare
export const getAggregationTypeFromPeriod = (startDate, endDate) => {
  const daysDiff = moment(endDate).diff((moment(startDate)), 'days')
  const hoursDiff = moment(endDate).diff(moment(startDate), 'hours')

  // Se il periodo è maggiore di un giorno richiedo i dati in forma giornaliera
  if (daysDiff > 1) {
    return 'daily'
  }
  // Se il periodo è maggiore di 12 ore richiedo i dati in forma oraria
  if (hoursDiff > 12) {
    return 'hourly'
  }

  // Se il periodo è mggiore di 1 ora richiedo i dati in forma quartoraria
  if (hoursDiff > 1) {
    return 'quarter'
  }

  // Se sono sotto 1 ora richiedo i dati puntuali
  return 'raw'
}

// Funzione che prende in ingresso un set di filtri per il grafico di regressione e li restituisce arrichiti della chiamata all'analisi di stringa
export const addStringAnalysisToDeviation = (filter, type) => {
  let filterCopy = { ...filter }

  const currentElements = (filter[type] && filter[type].length > 0 && filter[type][0].elements) || []
  if (currentElements.length > 0) {
    const stringAnalysisFilter = currentElements.map(el => ({
      show: true,
      elements: [{ ...el }]
    }))
    filterCopy = {
      ...filter,
      stringAnalysis: stringAnalysisFilter
    }
  }

  return filterCopy
}

// Utility che restituisce un filtro normalizzato
const normalizeFilter = (filterArray) => {
  return filterArray.map(singleFilter => ({
    ...singleFilter,
    elements: singleFilter.elements.map(el => ({
      uuid: el.uuid,
      name: el.name,
      deviceType: {
        category: el.deviceType?.category || null,
        properties: el.deviceType?.properties || {}
      }
    }))
  }))
}

// Funzione che rimuove le informazioni dei devices passati ad un filtro della sezione analytics
export const normalizeElementsFilter = (filter, type) => {
  // Copio il filtro per restituirlo
  const filterCopy = { ...filter }
  // Prendo l'oggetto del filtro del tipo selezionato
  const filterType = filter[type] || null
  // se esiste
  if (filterType) {
    // Se il tipo è regressione, devo normalizzare anche l'analisi di stringa
    if (type === 'deviation' && filter.stringAnalysis) {
      const normalizedStringAnalysis = normalizeFilter(filter.stringAnalysis)
      filterCopy.stringAnalysis = normalizedStringAnalysis
    }
    // altrimenti normalizzo solo il filtro del tipo passato
    const normalizedFilterType = normalizeFilter(filterType)
    filterCopy[type] = normalizedFilterType
  }

  return filterCopy
}

function getPlantSunTimes (plant, _now) {
  const now = new Date(_now)
  let sunrise = new Date(now)
  sunrise.setHours(5, 0, 0, 0)
  let sunset = new Date(now)
  sunset.setHours(22, 0, 0, 0)
  if (plant.location && plant.location.coordinates) {
    const suntimes = SunCalc.getTimes(new Date(now), plant.location.coordinates[1], plant.location.coordinates[0])
    sunrise = new Date(suntimes.sunrise)
    sunset = new Date(suntimes.sunset)
  }

  let sunriseMinutesOffset = 90
  let sunsetMinutesOffset = 90
  if (plant.metadata && plant.metadata.sunriseMinutesOffset && !isNaN(plant.metadata.sunriseMinutesOffset)) {
    sunriseMinutesOffset = Number(plant.metadata.sunriseMinutesOffset)
  }
  if (plant.metadata && plant.metadata.sunsetMinutesOffset && !isNaN(plant.metadata.sunsetMinutesOffset)) {
    sunsetMinutesOffset = Number(plant.metadata.sunsetMinutesOffset)
  }
  sunrise.setMinutes(sunrise.getMinutes() + sunriseMinutesOffset)
  sunset.setMinutes(sunset.getMinutes() - sunsetMinutesOffset)
  return { sunset, sunrise }
}

function isNightAtThePlant (plant, _now) {
  const now = new Date(_now)
  const { sunset, sunrise } = getPlantSunTimes(plant, now)
  // alog(`Dopo aver applicato gli offset, per l'impianto abbiamo sunrise=${sunrise.toISOString()} e sunset=${sunset.toISOString()}`, null, 'plant')
  return (now.getTime() < sunrise.getTime() || now.getTime() > sunset.getTime())
}
// funzione che ritorna la durata effettiva dell'anomalia (tiene conto solo delle ore di esercizio)
export const getAnomalyDuration = (_from, _to, plant) => {
  const from = new Date(_from)
  const to = new Date(_to)

  const cursor = new Date(from)
  let totalMinutes = 0
  while (cursor.getTime() < to.getTime()) {
    if (!isNightAtThePlant(plant, cursor)) {
      totalMinutes += 15
    }
    cursor.setMinutes(cursor.getMinutes() + 15)
  }

  // Diamo l'ouput in ms
  return totalMinutes * 60 * 1000
}

// funzione che torna il valore % rispetto al 100%
const returnPercentage = (data, minIndex, maxIndex) => {
  const val = (100 * data[minIndex]) / data[maxIndex]
  if (data[minIndex] && data[maxIndex]) {
    return fixedNum(val, 0)
  }
  return 0
}

// Funzione che ritorna formatta i dati di producibilità e PR per essere forniti al grafico
export const composeProductionData = (data) => {
  const productionData = {
    kwh: [
      data.realProduction !== '-' ? fixedNum(data.realProduction, 0) : 0,
      data.baselineProduction !== '-' ? fixedNum(data.baselineProduction, 0) : 0
    ],
    pr: [
      data.realPr !== '-' ? fixedNum(data.realPr, 2) : 0,
      data.baselinePr !== '-' ? fixedNum(data.baselinePr, 2) : 0
    ],
    producibility: 0,
    series: [0, 0]
  }

  productionData.productability =
    data.realProduction !== '-'
      ? (Number(productionData.kwh[0]) - Number(productionData.kwh[1])) / Number(productionData.kwh[1])
      : 0

  productionData.productability = fixedNum(productionData.productability, 2)
  // mi setto i valori da passare alla serie
  const maxValueIndex = Number(productionData.kwh[0]) > Number(productionData.kwh[1]) ? 0 : 1
  const minValueIndex = maxValueIndex === 0 ? 1 : 0
  // trovato il maggiore mi sistemo i dati per la serie
  productionData.series[0] = maxValueIndex === 0 ? '100' : returnPercentage(productionData.kwh, minValueIndex, maxValueIndex)
  productionData.series[1] = maxValueIndex === 1 ? '100' : returnPercentage(productionData.kwh, minValueIndex, maxValueIndex)

  return productionData
}
